/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_DescriptionInputs */

const en_blog_description = /** @type {(inputs: Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insights, updates and stories from our team`)
};

const es_blog_description = /** @type {(inputs: Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideas, novedades e historias de nuestro equipo`)
};

/**
* | output |
* | --- |
* | "Insights, updates and stories from our team" |
*
* @param {Blog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const blog_description = /** @type {((inputs?: Blog_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_description(inputs)
	return es_blog_description(inputs)
});